import { render } from "./SlidesScroll.vue?vue&type=template&id=45e76e66"
import script from "./SlidesScroll.vue?vue&type=script&lang=js"
export * from "./SlidesScroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__